"use client";

// Masaüstü split haritasını YALNIZCA lg'de (>=1024px) mount eder.
// Aksi halde react-leaflet, gizli (display:none) 0-boyut konteynerde başlatılıp
// boşa init olur + md→lg resize'da gri/kaymış tile sorunu yaşanır. useIsDesktop
// ile harita gerçekten görünür olduğunda mount edilir.

import { useIsDesktop } from "@/hooks";
import { SearchResultsMap, type MapListing } from "./search-results-map";

export function DesktopResultsMap({ listings }: { listings: MapListing[] }) {
  const isDesktop = useIsDesktop();
  if (!isDesktop) return null;
  return <SearchResultsMap listings={listings} />;
}
